import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefusalReceiveDamagesIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 43,
	viewBox: "0 0 35 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19.3306,
			cy: 6.5,
			rx: 2.68999,
			ry: 2.5,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.891,
			cy: 29.5,
			rx: 3.76599,
			ry: 3.5,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19.1252,
			cy: 19,
			rx: 12.0783,
			ry: 12,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.4693,
			cy: 36.5,
			rx: 2.53176,
			ry: 2.5,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.9346,
			cy: 42,
			rx: 1.0127,
			ry: 1,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.8721,
			cy: 1,
			rx: 1.0127,
			ry: 1,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0994 29.8332C21.0966 29.8332 26.0034 24.9582 26.0034 18.9998C26.0034 13.0415 21.0966 8.1665 15.0994 8.1665C9.10214 8.1665 4.19531 13.0415 4.19531 18.9998C4.19531 24.9582 9.10214 29.8332 15.0994 29.8332Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1016 14.6665V20.0832",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0938 23.3335H15.1035",
			stroke: "#7548F0",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRefusalReceiveDamagesIcon;
